export default __webpack_public_path__ + "static/topNavItems-anatomy-dark-de4080fe9f34d85061a828a9ec8e530ac5af426d989a8aab913df970f4b6e9ff.png";